import store from "@/store";
import { CLEAR_PM_AND_RATES_CACHE, GET_LOCALIZED_RATE } from "./actions.type";
const { dispatch } = store;

const init = () => {
  /**
   * Watches for changes to the currency selection (invoice step)
   *
   * when the value changes, compare country to the retrieved data
   * if there is a mismatch, cloar cached data and get the localized rate
   */
  store.watch(
    (state) => {
      return state.invoice.invoice.payment_currency;
    },
    (currency) => {
      // if currency is empty, do nothing
      if (currency === "") return;

      // if set, clear cache for payment methods and rates
      dispatch(CLEAR_PM_AND_RATES_CACHE);

      // derive the country from currency
      const countryObj = store.getters.countries.find(
        ({ currency: c }) => c === currency
      );

      // if no country is found from the currency, throw error
      if (!countryObj) throw new Error("Invalid currency", currency);

      const Country = countryObj.code;
      const { MerchantId } = store.getters.merchant;

      dispatch(GET_LOCALIZED_RATE, { MerchantId, Country });
    }
  );
};

export default { init };
